import axios from "axios";
// import AuthService from "@/services/AuthService";

const instance = axios.create({
  baseURL: process.env.VUE_APP_API,
});

// instance.interceptors.response.use(
// 	(response) => {
// 		if (response.data.jwtToken) {
// 			localStorage.setItem('token', response.data.jwtToken)
// 		}
// 		return response;
// 	},

// 	function (error) {
// 		const token = localStorage.getItem('token');
// 		if (error.response.status === 401 || error.response.status === 402 || error.response.status === 403 || error.response.status === 415 || token === null) {
// 			console.log("unauthorized, logging out ...");
// 			AuthService.logout()
// 		}
// 		return Promise.reject(error.response);
// 	}
// );

const TIMEOUT = 1000000;
export const onRequestSuccess = (config: any) => {
  const token = localStorage.getItem("token");
  if (token) {
    if (!config.headers) {
      config.headers = {};
    }
    config.headers.Authorization = `Bearer ${token}`;
  }
  config.timeout = TIMEOUT;
  return config;
};

instance.interceptors.request.use(onRequestSuccess);

export default instance;
